import React from 'react';
import { Polygon } from '@react-google-maps/api';
import { ZoneLabel } from '@src/core/features/zones/components/zones-control/components';
import { colorByType, options } from './styles';
import { ZonePolygonProps } from './types';

const ZonePolygon: React.FC<ZonePolygonProps> = (props) => {
  const { zone } = props;

  const color = colorByType[zone.zoneType];

  return (
    <React.Fragment>
      <ZoneLabel zone={zone} />
      <Polygon 
        path={zone.polygonCoordinates} 
        options={{ 
          ...options, 
          fillColor: color, 
          strokeColor: color,
          fillOpacity: 0.3,
        }} />
    </React.Fragment>
  );
};

export default ZonePolygon;